import React, { useEffect, useState } from 'react';
import { PdfPrintPreviewModal } from './PdfPrintPreviewModal';
import { registerPdfPrintPreviewHost } from './pdfPrintPreviewApi';

/**
 * Mount once near the app root so {@link openPdfPrintPreview} can show the modal.
 */
export function PdfPrintPreviewHost() {
    const [session, setSession] = useState(null);

    useEffect(() => {
        registerPdfPrintPreviewHost(setSession);
        return () => registerPdfPrintPreviewHost(null);
    }, []);

    if (!session) return null;

    return (
        <PdfPrintPreviewModal
            templateId={session.templateId}
            props={session.props}
            title={session.title}
            onPrinted={session.onPrinted}
            onCancel={session.onCancel}
        />
    );
}
